const VD_LOZENGE_CLASS = 'vd-lozenge'
const VD_LOZENGE_INTERACTIVE_CLASS = `${VD_LOZENGE_CLASS}--interactive`
const VD_LOZENGE_DISABLED_CLASS = `${VD_LOZENGE_CLASS}--disabled`
const VD_LOZENGE_MARKED_CLASS = `${VD_LOZENGE_CLASS}--marked`

/**
 * Lozenge controller
 */
class LozengeController {
  constructor($attrs) {
    'ngInject'
    this._$attrs = $attrs
  }

  $postLink() {
    const lozengeClasses = [VD_LOZENGE_CLASS]

    if (this.onDelete) {
      lozengeClasses.push(VD_LOZENGE_INTERACTIVE_CLASS)
    }

    this._$attrs.$addClass(lozengeClasses)
  }

  $onChanges(changes) {
    if (changes.disabled) {
      const disabled = changes.disabled.currentValue
      this._$attrs[disabled ? '$addClass' : '$removeClass'](
        VD_LOZENGE_DISABLED_CLASS
      )
    }
    if (changes.marked) {
      const marked = changes.marked.currentValue
      this._$attrs[marked ? '$addClass' : '$removeClass'](
        VD_LOZENGE_MARKED_CLASS
      )
      this.marked = marked
    }
  }

  onKeyPress($event) {
    // If the 'Space' key is pressed
    if ($event.keyCode === 32) {
      $event.preventDefault()
      this.onDelete()
    }
  }
}

export default LozengeController
